import { render, staticRenderFns } from "./PerfKpiCards.vue?vue&type=template&id=fd99192a&"
import script from "./PerfKpiCards.vue?vue&type=script&lang=js&"
export * from "./PerfKpiCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports